/**
 * Created by liux on 17/6/30.
 */
export default function (tel) {
  var t = String(tel).trim();
  if(!(/^1\d{10}$/.test(t))){
    return tel;
  }else {
    return t.substr(0,3)+'****'+t.substr(-4)
  }
}